export enum CONTRACT_STATUS {
	None = 0,
	Canceled = 1,
}
